import { createContext, useContext } from 'react';
import UserPanelStore from '@features/userPanel/mobx/stores/UserPanelStore';
let currentStore: UserPanelStore;
const initializeStore = () => {
  const newStore = currentStore ?? new UserPanelStore();
  if (!currentStore) currentStore = newStore;
  return newStore;
};
const UserPanelStoreContext = createContext<UserPanelStore>(initializeStore());
const useUserPanelStore = () => useContext(UserPanelStoreContext);
export { UserPanelStore, useUserPanelStore };